window.addEventListener('load', () => {
  const footermenutitle = document.querySelectorAll('.mobile_only .footer--block .footer--block--heading');
    
  footermenutitle.forEach(ele => {
    ele.addEventListener('click', () => {
      const footermenuwrapper = ele.closest('.footer--block');    
      footermenuwrapper.classList.toggle('active');  
    });
  });
  
  const openChatButton = document.getElementById("openChat");
  if (openChatButton && window.fcWidget) {
    openChatButton.addEventListener("click", () => {
      window.fcWidget.open();
    });
  }
});








// --- Variant family AJAX: section-based swap, keep theme JS as-is ---

// function ensureSectionStylesInHead(sectionEl) {
//   if (!sectionEl || !sectionEl.querySelectorAll) return;
//   var head = document.head;
//   sectionEl.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
//     var href = link.getAttribute('href');
//     if (!href) return;
//     if (document.querySelector('link[rel="stylesheet"][href="' + href.replace(/"/g, '\\"') + '"]')) return;
//     var newLink = document.createElement('link');
//     newLink.rel = 'stylesheet';
//     newLink.href = href;
//     newLink.media = link.getAttribute('media') || 'all';
//     head.appendChild(newLink);
//   });
// }



// document.addEventListener('click', function (e) {
//   var swatch = e.target.closest('.variant-family__swatch');
//   if (!swatch) return;

//   e.preventDefault();

//   var url = swatch.dataset.productUrl;
//   var root = document.querySelector('.product-page--root');

//   if (!url || !root) {
//     window.location.href = url || window.location.href;
//     return;
//   }

//   // avoid reloading the same product
//   if (swatch.classList.contains('is-active')) return;

//   var sectionWrapper = root.closest('[id^="shopify-section-"]');
//   var sectionId = sectionWrapper
//     ? sectionWrapper.id.replace('shopify-section-', '')
//     : (root.dataset.sectionId || '');

//   if (!sectionId) {
//     window.location.href = url;
//     return;
//   }

//   root.classList.add('is-loading');
//   document.body.classList.add('page-fade-out');

//   function clearLoading() {
//     root.classList.remove('is-loading');
//     document.body.classList.remove('page-fade-out');
//   }

//   fetch(url + '?sections=' + encodeURIComponent(sectionId))
//     .then(function (response) { return response.json(); })
//     .then(function (data) {
//       var html = data[sectionId];
//       if (!html) {
//         clearLoading();
//         window.location.href = url;
//         return;
//       }

//       var wrapper = document.createElement('div');
//       wrapper.innerHTML = html;

//       var newSection = wrapper.querySelector('#shopify-section-' + sectionId);
//       var currentSection = document.querySelector('#shopify-section-' + sectionId);

//       if (!newSection || !currentSection) {
//         clearLoading();
//         window.location.href = url;
//         return;
//       }

//       // ensure any section-level styles are present
//       ensureSectionStylesInHead(newSection);

//       currentSection.replaceWith(newSection);
//       window.history.replaceState({}, '', url);

//       // let existing theme JS re-initialize transitions / components
//       if (typeof theme !== 'undefined' && theme.transitions && typeof theme.transitions.load === 'function') {
//         theme.transitions.load();
//       }

//       var productRoot = newSection.querySelector('.product-page--root');
//       if (productRoot) {
//         productRoot.dispatchEvent(new CustomEvent('theme:section:load', { bubbles: true }));
//       }

//       window.dispatchEvent(new Event('resize'));
//       clearLoading();
//     })
//     .catch(function () {
//       clearLoading();
//       window.location.href = url;
//     });
// });